// extracted by mini-css-extract-plugin
export var menuIcon = "_r8-0";
export var menuIconInline = "_r8-1";